module.exports = __webpack_public_path__ + "static/media/centenarioUldaSD.05a44d9c.mp4";